import {get, filter} from 'lodash-es';
import {createSelector} from 'reselect';

import {isObjectArchived} from 'static/three-oh/src/modules/utils/dateHelpers';


const getAllAssignments = (state) => {
  return get(state, 'assignments.items', null);
};

export const assignmentsLoading = (state) => get(state, 'assignments.isLoading');

export const getAssignedAssignments = createSelector(
  getAllAssignments,
  (assignments) => {
    return filter(assignments, 'date_assigned');
  }
);

export const getAssignmentsForActiveClassrooms = createSelector(
  getAssignedAssignments,
  (assignments) => {
    return filter(assignments, (assignment) => {
      return assignment.classrooms.some((c) => {
        return !isObjectArchived(c);
      });
    });
  }
);
